<template>
  <div class="hc-schedule-calendar-wrap">
    <div class="hc-schedule-calendar-heading">
      <span class="hc-calendar-badge">
        <i class="far fa-calendar-alt mr-1"></i> Jadwal Mingguan Dokter
      </span>
    </div>

    <!-- Calendar Container -->
    <div class="hc-calendar-card-shell">
      <data-calendar
        ref="calendar"
        :now="today"
        :value="today"
        :events="events"
        :event-color="getEventColor"
        color="primary"
        type="week"
        :height="640"
        calendar-class="hc-v-calendar-modern"
        @click:event="showEvent"
        @change="getEvents" />

      <!-- Event Details Popover -->
      <v-menu
        v-model="selectedOpen"
        :close-on-content-click="false"
        :activator="selectedElement"
        offset-x
      >
        <v-card class="hc-event-popover-card" min-width="340px" flat>
          <v-toolbar :color="selectedEvent.color" dark flat class="hc-popover-toolbar">
            <v-toolbar-title class="hc-popover-title">
              <i class="fas fa-user-md mr-2"></i> Praktek {{ selectedEvent.name }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <button
              type="button"
              class="hc-popover-close-btn"
              @click="selectedOpen = false"
            >
              <i class="fas fa-times"></i>
            </button>
          </v-toolbar>
          <v-card-text class="hc-popover-body">
            <div class="d-flex align-items-start gap-3">
              <div class="hc-popover-icon-box">
                <i class="far fa-clock"></i>
              </div>
              <div>
                <span class="hc-popover-label">Waktu & Hari</span>
                <p class="hc-popover-text mb-0">{{ selectedEvent.details }}</p>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import DataCalendar from "@/component/common/DataCalendar.vue";

export default {
  components: {
    DataCalendar,
  },
  props: {
    doctorId: {
      type: [String, Number],
      default: null,
    },
  },

  data: () => ({
    today: window.medhopToday(),
    events: [],
    colors: [
      "var(--skin-secondary)",
      "var(--skin-primary)",
      "#2563eb",
      "var(--skin-secondary)",
      "#059669",
      "#d97706",
      "#db2777",
      "#0284c7",
    ],
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
  }),

  methods: {
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        let dayName = new Date(event.start).toLocaleDateString("id-ID", {
          weekday: "long",
        });
        let start = new Date(event.start).toLocaleTimeString("id-ID", {
          hour: "2-digit",
          minute: "2-digit",
        });
        let end = new Date(event.end).toLocaleTimeString("id-ID", {
          hour: "2-digit",
          minute: "2-digit",
        });
        this.selectedEvent.details = `Praktek ${event.name} Pada ${dayName} ${start} s/d ${end}`;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 30);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 30);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },

    getEventColor(event) {
      return event.color;
    },

    random(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    async getAppointment() {
      const doctorId = this.doctorId == null ? "" : this.doctorId;
      return await module.list(
        `schedules/get-calendar?doctor_id=${doctorId}`
      );
    },

    async getEvents() {
      let arr = [],
        date = this.getMonday(new Date());
      for (let i = 1; i <= 8; i++) {
        i == 1
          ? arr.push(new Date(date.setDate(date.getDate())))
          : arr.push(new Date(date.setDate(date.getDate() + 1)));
      }
      const events = [];
      const schedules = await this.getAppointment();
      let start, end;
      let usedColors = [];

      for (let i = 0; i < schedules.length; i++) {
        for (let j = 0; j < arr.length; j++) {
          if (
            schedules[i].day_name ==
            new Date(arr[j]).toLocaleString("id-ID", { weekday: "long" })
          ) {
            start = new Date(arr[j]);
            start.setHours(schedules[i].start_hour);
            start.setMinutes(schedules[i].start_minute);
            end = new Date(arr[j]);
            end.setHours(schedules[i].end_hour);
            end.setMinutes(schedules[i].end_minute);
            let day_number = start.getDay();
            if (day_number == 0) {
              start.setDate(start.getDate() - 7);
              end.setDate(end.getDate() - 7);
            }

            let availableColors = this.colors.filter(
              (color) => !usedColors.includes(color)
            );
            if (availableColors.length === 0) {
              usedColors = [];
              availableColors = this.colors.slice();
            }

            let randomIndex = this.random(0, availableColors.length - 1);
            let selectedColor = availableColors[randomIndex];
            usedColors.push(selectedColor);

            events.push({
              name: schedules[i].name,
              weekdays: 1,
              start: start,
              end: end,
              color: selectedColor,
              timed: true,
            });
          }
        }
      }
      this.events = events;
    },

    getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1);
      return new Date(d.setDate(diff));
    },
  },

  watch: {
    doctorId() {
      this.getEvents();
    },
  },

  mounted() {
    this.$refs.calendar.scrollToTime("08:00");
  },
};
</script>

<style lang="scss">
.hc-schedule-calendar-wrap {
  position: relative;
}

.hc-schedule-calendar-heading {
  display: flex;
  align-items: center;
  margin-bottom: 0.65rem;
}

.hc-calendar-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 20px;
  background: rgba(var(--skin-secondary-rgb), 0.08);
  color: var(--skin-secondary);
  font-size: 12px;
  font-weight: 600;

  i {
    color: var(--skin-secondary);
  }
}

.hc-calendar-card-shell {
  position: relative;
}

/* Modern Vuetify Calendar Overrides */
.hc-v-calendar-modern {
  &.v-calendar-daily {
    background: #ffffff !important;
    border: 0 !important;
  }

  /* Day Header */
  .v-calendar-daily__head {
    border-bottom: 1px solid #e2e8f0 !important;
    background: #f8fafc !important;
  }

  .v-calendar-daily_head-day {
    border-right: 1px solid #edf2f7 !important;
    padding: 12px 4px !important;
  }

  .v-calendar-daily_head-weekday {
    font-size: 11px !important;
    font-weight: 700 !important;
    letter-spacing: 0.08em !important;
    color: #64748b !important;
    text-transform: uppercase !important;
  }

  .v-calendar-daily_head-day-label {
    margin-bottom: 4px !important;

    .v-btn {
      font-size: 14px !important;
      font-weight: 600 !important;
      color: #334155;

      .v-btn__content {
        color: #334155;
      }

      &.v-btn--active,
      &.primary,
      &.accent {
        background: linear-gradient(135deg, var(--skin-primary), var(--skin-secondary)) !important;
        color: #ffffff !important;
        box-shadow: 0 4px 14px rgba(var(--skin-secondary-rgb), 0.35) !important;

        &, *, .v-btn__content {
          color: #ffffff !important;
        }
      }
    }
  }

  .v-calendar-daily_head-day.v-present,
  .v-calendar-daily_head-day-label.v-present {
    .v-btn {
      background: linear-gradient(135deg, var(--skin-primary), var(--skin-secondary)) !important;
      color: #ffffff !important;
      box-shadow: 0 4px 14px rgba(var(--skin-secondary-rgb), 0.35) !important;

      &, *, .v-btn__content {
        color: #ffffff !important;
      }
    }
  }

  /* Intervals Column (07, 08, 09...) */
  .v-calendar-daily__intervals-head,
  .v-calendar-daily__intervals-body {
    border-right: 1px solid #edf2f7 !important;
    background: #f8fafc !important;
    width: 60px !important;
  }

  .v-calendar-daily__interval-text {
    font-size: 11px !important;
    font-weight: 700 !important;
    color: #94a3b8 !important;
  }

  /* Grid Cells */
  .v-calendar-daily__day-interval,
  .v-calendar-daily__day {
    border-right: 1px solid #edf2f7 !important;
    border-bottom: 1px solid #f1f5f9 !important;
  }

  .v-calendar-daily__day:hover {
    background: rgba(var(--skin-secondary-rgb), 0.02) !important;
  }

  /* Event Pill Styling */
  .v-calendar-daily__event {
    border-radius: 8px !important;
    padding: 4px 8px !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease !important;

    &:hover {
      transform: scale(1.02);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important;
      z-index: 10 !important;
    }
  }

  /* Custom Thin Scrollbar */
  .v-calendar-daily__scroll-area::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .v-calendar-daily__scroll-area::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }

  .v-calendar-daily__scroll-area::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
}

/* Event Details Popover */
.hc-event-popover-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(var(--skin-deep-rgb), 0.14) !important;
  border: 1px solid #e7edf4 !important;
}

.hc-popover-toolbar {
  height: 52px !important;
  padding: 0 16px !important;
}

.hc-popover-title {
  font-size: 14px !important;
  font-weight: 700 !important;
}

.hc-popover-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.35);
  }
}

.hc-popover-body {
  padding: 20px !important;
  background: #ffffff !important;
}

.hc-popover-icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(var(--skin-secondary-rgb), 0.1);
  color: var(--skin-secondary);
  font-size: 15px;
  flex-shrink: 0;
}

.hc-popover-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  margin-bottom: 2px;
}

.hc-popover-text {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.5;
}
</style>
